var _excluded = ["id", "isChecked", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import { KeyboardEventKeys } from "../../../typings/types";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import space, { spaceFactor } from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
var defaultColor = "background";
var activeColor = "success";
var borderWidth = 1;
var borderRadius = "huge";
var containerWidthSpace = 6;
var containerHeightSpace = 3;
var containerGutterSpace = 0.5;
var dotSizeSpace = 2;
var Container = styled.label.withConfig({
  componentId: "sc-sk7lr4-0"
})(["display:flex;flex-shrink:0;width:", ";height:", ";cursor:pointer;"], space(containerWidthSpace), space(containerHeightSpace));
var Input = styled.input.withConfig({
  componentId: "sc-sk7lr4-1"
})(["display:none;"]);
var SliderTrack = styled.div.withConfig({
  componentId: "sc-sk7lr4-2"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";position:relative;flex-grow:1;border:", " solid ", ";border-radius:", ";background-color:", ";&::after{", ";content:\"\";display:block;position:absolute;top:", ";left:", ";width:", ";height:", ";border-radius:", ";background-color:", ";}", ":checked + &{border-color:", ";&::after{left:", ";background-color:", ";box-shadow:", ";}}"], transition("background-color", "border-color"), unit(borderWidth), getBorderColor(theme, defaultColor, "low"), getBorderRadius(theme, borderRadius), getColor(theme, defaultColor), transition("left", "box-shadow"), unit(containerGutterSpace * spaceFactor - borderWidth), space(containerGutterSpace), space(dotSizeSpace), space(dotSizeSpace), getBorderRadius(theme, borderRadius), getIconColor(theme, defaultColor, "low"), Input, getColor(theme, activeColor), space(containerWidthSpace - containerGutterSpace - dotSizeSpace), getColor(theme, activeColor), getBoxShadow(theme, "tiny"));
});
function ToggleSwitchAtm(_ref2) {
  var id = _ref2.id,
    isChecked = _ref2.isChecked,
    onClick = _ref2.onClick,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(Container, _extends({
    htmlFor: id
  }, restProps, {
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React.createElement(Input, {
    id: id,
    checked: isChecked,
    onChange: onClick,
    type: "checkbox"
  }), /*#__PURE__*/React.createElement(SliderTrack, null));
}
export default ToggleSwitchAtm;